import { render, staticRenderFns } from "./product-default.vue?vue&type=template&id=0951ca6c&functional=true&"
import script from "./product-default.vue?vue&type=script&lang=ts&"
export * from "./product-default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports